export class OwnerRightesAndPrivilegeRawDto {
  hasVotingRight: boolean;
  hasAmenityPrivilege: boolean;
}
